import _merge from "lodash/merge";
import _noop from "lodash/noop";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Popover } from '@nextiva/next-ui';

var TablePopover =
/*#__PURE__*/
function (_Component) {
  _inherits(TablePopover, _Component);

  function TablePopover() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, TablePopover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = TablePopover.__proto__ || Object.getPrototypeOf(TablePopover)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        isPopoverOpen: false
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "togglePopover", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        e && e.stopPropagation();

        _this.setState({
          isPopoverOpen: !_this.state.isPopoverOpen
        }, _this.props.onToggle);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(event) {
        _this.togglePopover();

        event.stopPropagation(); // Prevent reopening after closing by clicking outside the popover body but on the button

        if (_this.outerActionClickTarget !== event.target) {
          _this.togglePopover();
        }

        _this.outerActionClickTarget = undefined;
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleOuterAction", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.props.onOuterAction(e);

        _this.togglePopover(e);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "getPopper", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            popper = _this$props.popper,
            getTableRef = _this$props.getTableRef;
        var tableRef = getTableRef && getTableRef();
        return tableRef ? _merge(popper, {
          modifiers: {
            preventOverflow: {
              enabled: true,
              boundariesElement: tableRef
            },
            setMaxRect: {
              enabled: true,
              order: 860,
              fn: function fn(data) {
                data.styles.maxHeight = Math.max(tableRef.offsetHeight - 10, 0);
                data.styles.maxWidth = Math.max(tableRef.offsetWidth - 10, 0);
                return data;
              }
            }
          }
        }) : popper;
      }
    }), _temp));
  }

  _createClass(TablePopover, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState !== this.state;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          Body = _props.body,
          arrow = _props.arrow;
      return React.createElement("div", null, React.createElement(Popover, {
        bodyClassName: cx('nx-table-popover', className),
        body: React.createElement(Body, {
          togglePopover: this.togglePopover
        }),
        onClickOutside: this.handleOuterAction,
        isOpen: this.state.isPopoverOpen,
        arrow: arrow,
        popper: this.getPopper()
      }, React.cloneElement(this.props.children, {
        onClick: this.handleClick
      })));
    }
  }]);

  return TablePopover;
}(Component);

Object.defineProperty(TablePopover, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    className: PropTypes.string,
    onOuterAction: PropTypes.func,
    handleClick: PropTypes.func,
    onToggle: PropTypes.func,
    getTableRef: PropTypes.func
  }
});
Object.defineProperty(TablePopover, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onOuterAction: _noop
  }
});
export { TablePopover as default };